// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JZq6Y","name":"styles_name__3yL_2","phone":"styles_phone__4IuQC"};